<template>
    <div class="delete-account">
        
         <!-- deletion reasons -->
        <div class="form__title h5" v-translate>reason_for_deletion</div>
        <div class="delete-account__reasons">
            <div class="delete-account__reasons__item" :class="{'active' : reason.active}" v-for="(reason,idx) in reasons" :key="reason.key" @click="toggleReason(idx)">
                {{ reason.name }}
            </div>
        </div>

        <!-- other -->
        <div class="delete-account__other">
            <div class="text text--bold">Other:</div>

           <div class="form__row form__row--multiple form__row--space-below delete-account__other__input">
                <div class="form__item">
                    <input type="text" class="form__field form__field--text" v-model="formData.comment" @input="requiredFieldChange">
                </div>
            </div>
        </div>

         <div class="form__error" v-if="errors.indexOf('reasons') >= 0" v-translate>at_least_one_reason</div>
        <!-- current password -->
       
       <template v-if="!user.socialLogin">
            <div class="form__title h5" v-translate>current_password</div>
            <div class="form__text text"><translate>current_password_intro</translate>:</div>

            <div class="form__item">
                <input type="password" class="form__field form__field--text" v-model="formData.currentPassword" @input="requiredFieldChange">
                <div class="form__error" v-if="errors.indexOf('currentPassword') >= 0 && !user.socialLogin" v-translate>current_password_required</div>
                <div class="form__error" v-if="errors.indexOf('current-password-wrong') >= 0" v-translate>wrong_password</div>
            </div>
       </template>

       <template v-if="user.socialLogin">
            <div class="form__title h5" v-translate>confirm_deletion</div>
            <div class="form__text text"> Please type <strong>delete</strong> in case you really want to delete your account</div>

            <div class="form__item">
                <input type="password" class="form__field form__field--text" v-model="formData.currentPassword" @input="requiredFieldChange">
                <div class="form__error" v-if="errors.indexOf('delete') >= 0 && user.socialLogin" v-translate>confirm_delete</div>
            </div> 
       </template>

         <!-- separator -->
        <div class="delete-account__separator"></div>

        <!-- button -->
        <div class="form__row">
            <div class="form__item">
                <puma-button class="button button--outline delete-account__button" :disabled="!isFormValid" @click="openModal()"><translate>delete_account_button</translate></puma-button>
                <div class="form__error form__error--success" v-if="success">
                    <div>Account is successfully deleted!</div>
                </div> 
            </div>
        </div>

        <!--modal-->
        <div class="delete-account__modal__overlay" v-if="deleteModal">
           <div class="delete-account__modal" :class="{'loading' : loading}">
               <transition name="fade-slow"  v-if="loading">
                    <loader class="delete-account__loader"  color="black"></loader>
                </transition>
               <template v-else>
                   <div class="form__title h5" v-translate>delete_your_account</div>
                    <div class="form__text text"><translate>delete_your_account_intro</translate></div>
                
                    <div class="delete-account__modal__buttons">
                        <puma-button class="button button--outline delete-account__button" @click="deleteModal = false"><translate>delete_account_button_cancel</translate></puma-button>
                        <puma-button class="button button--red delete-account__modal__button" @click="deleteAccount()"><translate>delete_account_button_delete</translate></puma-button>
                    </div>
               </template>
           </div>
        </div>
    </div>
</template>
<script>
import * as api from '../api';
import { mapGetters } from "vuex";
import { user } from '../store/getters';

    export default {

        computed: {
            ...mapGetters(['user']),

            isFormValid() {
                return this.errors.length === 0;
            }
        },

        data() {
            return {
                errors: [],
                success: false,
                loading: false,
                deleteModal: false,
                userData: null,
                reasons: [
                    { id: 0, key: 'duplicated_account', name: 'I have a duplicate account' , active: false},
                    { id: 1, key: 'not_what_expected', name: 'PUMATRAC was not what I expected', active: false},
                    { id: 2, key: 'technical_issues', name: 'I experience technical issues', active: false},
                    { id: 3, key: 'privacy_concerns', name: 'Privacy concerns', active: false},
                ],

                formData: {
                    currentPassword: '',
                    tagIds: [],
                    comment: '',
                } 
            }
        },

        methods: {
            requiredFieldChange() {
                this.errors = []

                if(this.formData.currentPassword === '' && !this.user.socialLogin) {
                    this.errors.push('currentPassword');
                }

                if(this.formData.currentPassword !=='delete' && this.user.socialLogin) {
                    this.errors.push('delete');
                }

                 if (this.formData.tagIds.length < 1 && this.formData.comment === '' ) {
                     this.errors.push('reasons');
                 }
            },

            openModal() {
                this.requiredFieldChange();
                
                if(this.errors.length === 0) {
                    this.deleteModal = true;
                }
            },
            toggleReason(idx) {
                let setActiveReason = this.reasons[idx]

                setActiveReason.active = !setActiveReason.active 

                let tagIdx = this.formData.tagIds.indexOf(setActiveReason.key)

                if (tagIdx === -1)
                    this.formData.tagIds.push(setActiveReason.key)
                else
                    this.formData.tagIds.splice(tagIdx, 1)

                if (this.formData.tagIds.length < 1 && this.formData.comment === '' ) 
                    this.errors.push('reasons')
                else 
                    this.errors = this.errors.filter(error => {return error !== 'reasons'})
              
            },

            async deleteAccount() {
                this.loading = true;
                let data = {user: this.formData};
                try {
                    await api.users.deleteAccount(data);
                    this.loading = false;
                    this.success = true;
                    this.$router.go('/');
            
                } catch(error) {
                    if(error.response.status === 403 && !this.user.socialLogin) {
                        this.errors.push('current-password-wrong')
                    }

                    if(error.response.status === 403 && this.user.socialLogin) {
                        this.errors.push('delete')
                    }

                    console.error(error)
                } finally {
                    this.loading = false;
                    this.deleteModal = false;
                }
            }
            
        }
    }
</script>
<style lang="scss" scoped>

.delete-account {
    $block: &;
    max-width: 578px;
    width: 100%;
    padding-bottom: 80px;

    &__reasons {
        display: flex;
        flex-wrap: wrap;

        &__item {
            display: flex;
            align-items: center;
            height: 36px;
            border-radius: 500px;
            border: 1px solid $puma-color-neutral-20;
            padding: 0 16px;
            margin: 0 10px 15px 0;
            transition: all 200ms $ease-out-quad;
            cursor: pointer;

            &.active {
                background: black;
                color: white;
                border-color: black;
            }
        }
    }

    &__other {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 16px;

        &__input {
            width: 100%;
            margin-left: 12px;

            .form__item {
                width: 100%;
            }
        };
    }

    &__separator {
        width: 100%;
        height: 1px;
        background-color: $puma-color-neutral-10;
        margin: 40px 0;
    }

    &__button {
        
        &:hover {
            background: $puma-color-black;
            color: $puma-color-white;
        }
    }

    &__loader {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: auto;
            width: 40px;
            height: 40px;
    }

    &__modal {

        max-width: 559px;
        width: 100%;
        height: 215px;
        background-color: $puma-color-white;
        padding: 24px 40px 30px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        &__overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba($puma-color-black, .5); 
            direction: flex;
            justify-content: center;
            align-items: center;
            transition: .25s all ease;
        }

        &__buttons {
            display: flex;
            flex-direction: row;
            column-gap: 13px;
        }

        &__button {

            &:hover {
                color: $puma-color-brand-60;
            }
        }

         @media only screen and (max-width: 768px) {
            top: 10%;
            left: 50%;
            transform: translateX(-50%);
        }

         @media only screen and (max-width: 560px) {
             max-width: 300px;
         }

         &.loading {
             display: flex;
             justify-content: center;
             align-items: center;
         }
    }

}
</style>